import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import { ModalProvider } from './components/Modal.js';
import { showModal, hideModal, Modal } from './components/Modal.js';

import SignedOut from './modals/SignedOut.js';

import NavigationBar from './components/NavigationBar.js';
import TopBar from './components/TopBar.js';

import Home from './views/Home.js';
import Spending from './views/Spending.js';
import Buckets from './views/Buckets.js';
import People from './views/People.js';

function App() {
	const [scrollAtTop, setScrollAtTop] = useState(true);
	const [scrollAtBottom, setScrollAtBottom] = useState(false);

	const [numberValue, setNumberValue] = useState(2300);

	const [fuelData, setFuelData] = useState({
		label: 'Fuel',
		emoji: '⛽',
		valueLeft: 20,
		valueTotal: 100,
		percentage: 100,
		colour: 'green'
	});

	const [groceriesData, setGroceriesData] = useState({
		label: 'Fuel',
		emoji: '⛽',
		valueLeft: 300,
		valueTotal: 300,
		percentage: 100,
		colour: 'green'
	});

	const handleScroll = () => {
		const scrollTop = window.scrollY;
		const windowHeight = window.innerHeight;
		const documentHeight = document.documentElement.scrollHeight;
	
		// Check if the scroll is within 10px of the top
		if (scrollTop <= 10) {
		  	setScrollAtTop(true);
		} else {
		  	setScrollAtTop(false);
		}
	
		// Check if the scroll is within 10px of the bottom
		if (scrollTop + windowHeight >= documentHeight - 10) {
		  	setScrollAtBottom(true);
		} else {
		  	setScrollAtBottom(false);
		}
	};

	useEffect(() => {
		// Run the scroll handler once to capture initial scroll position
		handleScroll();
	
		// Add event listener for scroll
		window.addEventListener('scroll', handleScroll);
	
		// Clean up event listener on unmount
		return () => {
		  window.removeEventListener('scroll', handleScroll);
		};
	}, [useLocation()]);

	useEffect(() => {
		const percentage = Math.max(0, Math.min(100, (fuelData.valueLeft / fuelData.valueTotal) * 100));
		let colour;

		if (percentage > 50) {
			colour = 'green';
		} else if (percentage > 30) {
			colour = 'amber';
		} else {
			colour = 'red';
		}

		setFuelData(prevData => ({
			...prevData,
			percentage,
			colour,
		}));
	}, [fuelData.valueLeft, fuelData.valueTotal]);

	useEffect(() => {
		const percentage = Math.max(0, Math.min(100, (groceriesData.valueLeft / groceriesData.valueTotal) * 100));
		let colour;

		if (percentage > 50) {
			colour = 'green';
		} else if (percentage > 30) {
			colour = 'amber';
		} else {
			colour = 'red';
		}

		setGroceriesData(prevData => ({
			...prevData,
			percentage,
			colour,
		}));
	}, [groceriesData.valueLeft, groceriesData.valueTotal]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [useLocation()]);

	useEffect(() => {
		showModal(
            <Modal isClosable={false} innerClasses={'flex flex-col items-center justify-center h-full w-full'}>
				<SignedOut hideModal={() => hideModal()} />
            </Modal>
        ); 
	}, []);


	return (
		<ModalProvider>
			<div className='App block relative bg-slate-50 dark:bg-slate-900 min-h-dvh w-full max-w-[600px] mx-auto'>
				<Routes>
					<Route path='/' element={
						<>
						<div className='block fixed bg-gradient-to-r from-teal-500 to-purple-500 w-full h-[300px] top-0 left-0 after:block after:absolute after:bottom-0 after:left-0 after:w-full after:h-full after:bg-gradient-to-t after:from-slate-50 after:to-slate-50/0 opacity-20 dark:after:from-slate-900 dark:after:to-slate-900/0'></div>
						<TopBar scrollAtTop={scrollAtTop} showLogo={true} />
						<NavigationBar scrollAtBottom={scrollAtBottom} />
						<Home numberValue={numberValue} fuelData={fuelData} groceriesData={groceriesData} />
						</>
					} />

					<Route path='/spending' element={
						<>
						<TopBar scrollAtTop={scrollAtTop} heading={'Spending'} />
						<NavigationBar scrollAtBottom={scrollAtBottom} />
						<Spending />
						</>
					} />

					<Route path='/buckets' element={
						<>
						<TopBar scrollAtTop={scrollAtTop} heading={'Buckets'} />
						<NavigationBar scrollAtBottom={scrollAtBottom} />
						<Buckets fuelData={fuelData} groceriesData={groceriesData} />
						</>
					} />

					<Route path='/people' element={
						<>
						<TopBar scrollAtTop={scrollAtTop} heading={'People'} />
						<NavigationBar scrollAtBottom={scrollAtBottom} />
						<People />
						</>
					} />

					<Route path='/budget' element={
						<>
						<TopBar scrollAtTop={scrollAtTop} heading={'Budget'} />
						<NavigationBar scrollAtBottom={scrollAtBottom} />
						</>
					} />
				</Routes>
			</div>
		</ModalProvider>
	);
}

export default App;
